/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";

import { nmibleInstanceV3 } from "../../mutator/axios-instance-v3";

import type {
  BodyUploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost,
  DataResponseListPendingDocumentResponse,
  ErrorResponse,
  HTTPValidationError,
  LegalDocumentAcceptanceRequest,
  LegalDocumentCreate,
  LegalDocumentListRead,
  LegalDocumentRead,
  LegalDocumentRequirementScope,
  LegalDocumentUpdate,
  LegalDocumentVersionCreate,
  LegalDocumentVersionCreateRequest,
  LegalDocumentVersionCreateResponse,
  LegalDocumentVersionFileRead,
  LegalDocumentVersionLinkRequest,
  LegalDocumentVersionRead,
  LegalDocumentVersionUpdate,
  ListMyLegalDocumentsParticipantsMeLegalDocumentsGetParams,
  PendingDocumentResponse,
} from "../../model";
import type { ErrorType, BodyType } from "../../mutator/axios-instance-v3";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Get all legal documents with their versions
 * @summary List Legal Documents
 */
export const listLegalDocumentsLegalDocumentsGet = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<LegalDocumentListRead[]>(
    { url: `/legal-documents`, method: "GET", signal },
    options
  );
};

export const getListLegalDocumentsLegalDocumentsGetQueryKey = () => {
  return [`/legal-documents`] as const;
};

export const getListLegalDocumentsLegalDocumentsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListLegalDocumentsLegalDocumentsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>
  > = ({ signal }) =>
    listLegalDocumentsLegalDocumentsGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListLegalDocumentsLegalDocumentsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>
>;
export type ListLegalDocumentsLegalDocumentsGetQueryError =
  ErrorType<ErrorResponse>;

export function useListLegalDocumentsLegalDocumentsGet<
  TData = Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>,
          TError,
          Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListLegalDocumentsLegalDocumentsGet<
  TData = Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>,
          TError,
          Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListLegalDocumentsLegalDocumentsGet<
  TData = Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Legal Documents
 */

export function useListLegalDocumentsLegalDocumentsGet<
  TData = Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLegalDocumentsLegalDocumentsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListLegalDocumentsLegalDocumentsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a new legal document
 * @summary Create Legal Document
 */
export const createLegalDocumentLegalDocumentsPost = (
  legalDocumentCreate: BodyType<LegalDocumentCreate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<LegalDocumentRead>(
    {
      url: `/legal-documents`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: legalDocumentCreate,
      signal,
    },
    options
  );
};

export const getCreateLegalDocumentLegalDocumentsPostMutationKey = () =>
  ["createLegalDocumentLegalDocumentsPost"] as const;

export const getCreateLegalDocumentLegalDocumentsPostMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLegalDocumentLegalDocumentsPost>>,
    TError,
    CreateLegalDocumentLegalDocumentsPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLegalDocumentLegalDocumentsPost>>,
  TError,
  CreateLegalDocumentLegalDocumentsPostMutationVariables,
  TContext
> => {
  const mutationKey = getCreateLegalDocumentLegalDocumentsPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLegalDocumentLegalDocumentsPost>>,
    CreateLegalDocumentLegalDocumentsPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createLegalDocumentLegalDocumentsPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLegalDocumentLegalDocumentsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLegalDocumentLegalDocumentsPost>>
>;
export type CreateLegalDocumentLegalDocumentsPostMutationBody =
  BodyType<LegalDocumentCreate>;
export type CreateLegalDocumentLegalDocumentsPostMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface CreateLegalDocumentLegalDocumentsPostMutationVariables {
  data: BodyType<LegalDocumentCreate>;
}

/**
 * @summary Create Legal Document
 */
export const useCreateLegalDocumentLegalDocumentsPost = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createLegalDocumentLegalDocumentsPost>>,
      TError,
      CreateLegalDocumentLegalDocumentsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createLegalDocumentLegalDocumentsPost>>,
  TError,
  CreateLegalDocumentLegalDocumentsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateLegalDocumentLegalDocumentsPostMutationOptions(options),
    queryClient
  );
};
/**
 * Fetch the active legal documents for a requirement scope.
 *
 * Documents are identified by their ``required_for`` scope rather than their
 * title, so the lookup is spelling- and locale-independent: the Highnote card
 * holder agreement is always the ``HIGHNOTE_CARDHOLDERS`` document, and the
 * Stripe US programme's E-Sign Disclosure and Authorized User Terms are both
 * ``US_STRIPE_CARDHOLDERS``. A client must present every returned document.
 *
 * Requires an authenticated participant. Returns the matching documents in
 * display order (an empty list when none is active). Each
 * ``version.document_url`` is resolved for the language in the
 * ``Accept-Language`` header (with regional fallback, defaulting to English),
 * the same way the pending/accepted lists do.
 * @summary Get Legal Documents By Scope
 */
export const getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet = (
  requiredFor: LegalDocumentRequirementScope,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<DataResponseListPendingDocumentResponse>(
    { url: `/legal-documents/scope/${requiredFor}`, method: "GET", signal },
    options
  );
};

export const getGetLegalDocumentsByScopeLegalDocumentsScopeRequiredForGetQueryKey =
  (requiredFor: LegalDocumentRequirementScope) => {
    return [`/legal-documents/scope/${requiredFor}`] as const;
  };

export const getGetLegalDocumentsByScopeLegalDocumentsScopeRequiredForGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet
      >
    >,
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
  >(
    requiredFor: LegalDocumentRequirementScope,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof nmibleInstanceV3>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLegalDocumentsByScopeLegalDocumentsScopeRequiredForGetQueryKey(
        requiredFor
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet
        >
      >
    > = ({ signal }) =>
      getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet(
        requiredFor,
        requestOptions,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: requiredFor !== null && requiredFor !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetLegalDocumentsByScopeLegalDocumentsScopeRequiredForGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet
      >
    >
  >;
export type GetLegalDocumentsByScopeLegalDocumentsScopeRequiredForGetQueryError =
  ErrorType<ErrorResponse | HTTPValidationError>;

export function useGetLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet<
  TData = Awaited<
    ReturnType<typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  requiredFor: LegalDocumentRequirementScope,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet<
  TData = Awaited<
    ReturnType<typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  requiredFor: LegalDocumentRequirementScope,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet<
  TData = Awaited<
    ReturnType<typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  requiredFor: LegalDocumentRequirementScope,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Legal Documents By Scope
 */

export function useGetLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet<
  TData = Awaited<
    ReturnType<typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  requiredFor: LegalDocumentRequirementScope,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLegalDocumentsByScopeLegalDocumentsScopeRequiredForGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetLegalDocumentsByScopeLegalDocumentsScopeRequiredForGetQueryOptions(
      requiredFor,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Batch accept legal documents for the authenticated participant.
 * @summary Accept Legal Documents
 */
export const acceptLegalDocumentsLegalDocumentsAcceptPost = (
  legalDocumentAcceptanceRequest: BodyType<LegalDocumentAcceptanceRequest>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<unknown>(
    {
      url: `/legal-documents/accept`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: legalDocumentAcceptanceRequest,
      signal,
    },
    options
  );
};

export const getAcceptLegalDocumentsLegalDocumentsAcceptPostMutationKey = () =>
  ["acceptLegalDocumentsLegalDocumentsAcceptPost"] as const;

export const getAcceptLegalDocumentsLegalDocumentsAcceptPostMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptLegalDocumentsLegalDocumentsAcceptPost>>,
    TError,
    AcceptLegalDocumentsLegalDocumentsAcceptPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptLegalDocumentsLegalDocumentsAcceptPost>>,
  TError,
  AcceptLegalDocumentsLegalDocumentsAcceptPostMutationVariables,
  TContext
> => {
  const mutationKey =
    getAcceptLegalDocumentsLegalDocumentsAcceptPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptLegalDocumentsLegalDocumentsAcceptPost>>,
    AcceptLegalDocumentsLegalDocumentsAcceptPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return acceptLegalDocumentsLegalDocumentsAcceptPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptLegalDocumentsLegalDocumentsAcceptPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof acceptLegalDocumentsLegalDocumentsAcceptPost>>
  >;
export type AcceptLegalDocumentsLegalDocumentsAcceptPostMutationBody =
  BodyType<LegalDocumentAcceptanceRequest>;
export type AcceptLegalDocumentsLegalDocumentsAcceptPostMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface AcceptLegalDocumentsLegalDocumentsAcceptPostMutationVariables {
  data: BodyType<LegalDocumentAcceptanceRequest>;
}

/**
 * @summary Accept Legal Documents
 */
export const useAcceptLegalDocumentsLegalDocumentsAcceptPost = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof acceptLegalDocumentsLegalDocumentsAcceptPost>>,
      TError,
      AcceptLegalDocumentsLegalDocumentsAcceptPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof acceptLegalDocumentsLegalDocumentsAcceptPost>>,
  TError,
  AcceptLegalDocumentsLegalDocumentsAcceptPostMutationVariables,
  TContext
> => {
  return useMutation(
    getAcceptLegalDocumentsLegalDocumentsAcceptPostMutationOptions(options),
    queryClient
  );
};
/**
 * Update an existing legal document
 * @summary Update Legal Document
 */
export const updateLegalDocumentLegalDocumentsDocumentIdPut = (
  documentId: string,
  legalDocumentUpdate: BodyType<LegalDocumentUpdate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<LegalDocumentRead>(
    {
      url: `/legal-documents/${documentId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: legalDocumentUpdate,
      signal,
    },
    options
  );
};

export const getUpdateLegalDocumentLegalDocumentsDocumentIdPutMutationKey =
  () => ["updateLegalDocumentLegalDocumentsDocumentIdPut"] as const;

export const getUpdateLegalDocumentLegalDocumentsDocumentIdPutMutationOptions =
  <
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateLegalDocumentLegalDocumentsDocumentIdPut>
      >,
      TError,
      UpdateLegalDocumentLegalDocumentsDocumentIdPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateLegalDocumentLegalDocumentsDocumentIdPut>>,
    TError,
    UpdateLegalDocumentLegalDocumentsDocumentIdPutMutationVariables,
    TContext
  > => {
    const mutationKey =
      getUpdateLegalDocumentLegalDocumentsDocumentIdPutMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateLegalDocumentLegalDocumentsDocumentIdPut>
      >,
      UpdateLegalDocumentLegalDocumentsDocumentIdPutMutationVariables
    > = (props) => {
      const { documentId, data } = props ?? {};

      return updateLegalDocumentLegalDocumentsDocumentIdPut(
        documentId,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateLegalDocumentLegalDocumentsDocumentIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateLegalDocumentLegalDocumentsDocumentIdPut>>
  >;
export type UpdateLegalDocumentLegalDocumentsDocumentIdPutMutationBody =
  BodyType<LegalDocumentUpdate>;
export type UpdateLegalDocumentLegalDocumentsDocumentIdPutMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface UpdateLegalDocumentLegalDocumentsDocumentIdPutMutationVariables {
  documentId: string;
  data: BodyType<LegalDocumentUpdate>;
}

/**
 * @summary Update Legal Document
 */
export const useUpdateLegalDocumentLegalDocumentsDocumentIdPut = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateLegalDocumentLegalDocumentsDocumentIdPut>
      >,
      TError,
      UpdateLegalDocumentLegalDocumentsDocumentIdPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateLegalDocumentLegalDocumentsDocumentIdPut>>,
  TError,
  UpdateLegalDocumentLegalDocumentsDocumentIdPutMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateLegalDocumentLegalDocumentsDocumentIdPutMutationOptions(options),
    queryClient
  );
};
/**
 * Delete a legal document (soft delete)
 * @summary Delete Legal Document
 */
export const deleteLegalDocumentLegalDocumentsDocumentIdDelete = (
  documentId: string,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<void>(
    { url: `/legal-documents/${documentId}`, method: "DELETE", signal },
    options
  );
};

export const getDeleteLegalDocumentLegalDocumentsDocumentIdDeleteMutationKey =
  () => ["deleteLegalDocumentLegalDocumentsDocumentIdDelete"] as const;

export const getDeleteLegalDocumentLegalDocumentsDocumentIdDeleteMutationOptions =
  <
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteLegalDocumentLegalDocumentsDocumentIdDelete>
      >,
      TError,
      DeleteLegalDocumentLegalDocumentsDocumentIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteLegalDocumentLegalDocumentsDocumentIdDelete>
    >,
    TError,
    DeleteLegalDocumentLegalDocumentsDocumentIdDeleteMutationVariables,
    TContext
  > => {
    const mutationKey =
      getDeleteLegalDocumentLegalDocumentsDocumentIdDeleteMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteLegalDocumentLegalDocumentsDocumentIdDelete>
      >,
      DeleteLegalDocumentLegalDocumentsDocumentIdDeleteMutationVariables
    > = (props) => {
      const { documentId } = props ?? {};

      return deleteLegalDocumentLegalDocumentsDocumentIdDelete(
        documentId,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteLegalDocumentLegalDocumentsDocumentIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteLegalDocumentLegalDocumentsDocumentIdDelete>
    >
  >;

export type DeleteLegalDocumentLegalDocumentsDocumentIdDeleteMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface DeleteLegalDocumentLegalDocumentsDocumentIdDeleteMutationVariables {
  documentId: string;
}

/**
 * @summary Delete Legal Document
 */
export const useDeleteLegalDocumentLegalDocumentsDocumentIdDelete = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteLegalDocumentLegalDocumentsDocumentIdDelete>
      >,
      TError,
      DeleteLegalDocumentLegalDocumentsDocumentIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteLegalDocumentLegalDocumentsDocumentIdDelete>>,
  TError,
  DeleteLegalDocumentLegalDocumentsDocumentIdDeleteMutationVariables,
  TContext
> => {
  return useMutation(
    getDeleteLegalDocumentLegalDocumentsDocumentIdDeleteMutationOptions(
      options
    ),
    queryClient
  );
};
/**
 * Create a new version for a legal document
 * @summary Create Legal Document Version
 */
export const createLegalDocumentVersionLegalDocumentsDocumentIdVersionsPost = (
  documentId: string,
  legalDocumentVersionCreateRequest: BodyType<LegalDocumentVersionCreateRequest>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<LegalDocumentVersionCreateResponse>(
    {
      url: `/legal-documents/${documentId}/versions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: legalDocumentVersionCreateRequest,
      signal,
    },
    options
  );
};

export const getCreateLegalDocumentVersionLegalDocumentsDocumentIdVersionsPostMutationKey =
  () =>
    ["createLegalDocumentVersionLegalDocumentsDocumentIdVersionsPost"] as const;

export const getCreateLegalDocumentVersionLegalDocumentsDocumentIdVersionsPostMutationOptions =
  <
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createLegalDocumentVersionLegalDocumentsDocumentIdVersionsPost
        >
      >,
      TError,
      CreateLegalDocumentVersionLegalDocumentsDocumentIdVersionsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createLegalDocumentVersionLegalDocumentsDocumentIdVersionsPost
      >
    >,
    TError,
    CreateLegalDocumentVersionLegalDocumentsDocumentIdVersionsPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getCreateLegalDocumentVersionLegalDocumentsDocumentIdVersionsPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createLegalDocumentVersionLegalDocumentsDocumentIdVersionsPost
        >
      >,
      CreateLegalDocumentVersionLegalDocumentsDocumentIdVersionsPostMutationVariables
    > = (props) => {
      const { documentId, data } = props ?? {};

      return createLegalDocumentVersionLegalDocumentsDocumentIdVersionsPost(
        documentId,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateLegalDocumentVersionLegalDocumentsDocumentIdVersionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createLegalDocumentVersionLegalDocumentsDocumentIdVersionsPost
      >
    >
  >;
export type CreateLegalDocumentVersionLegalDocumentsDocumentIdVersionsPostMutationBody =
  BodyType<LegalDocumentVersionCreateRequest>;
export type CreateLegalDocumentVersionLegalDocumentsDocumentIdVersionsPostMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface CreateLegalDocumentVersionLegalDocumentsDocumentIdVersionsPostMutationVariables {
  documentId: string;
  data: BodyType<LegalDocumentVersionCreateRequest>;
}

/**
 * @summary Create Legal Document Version
 */
export const useCreateLegalDocumentVersionLegalDocumentsDocumentIdVersionsPost =
  <TError = ErrorType<ErrorResponse | HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createLegalDocumentVersionLegalDocumentsDocumentIdVersionsPost
          >
        >,
        TError,
        CreateLegalDocumentVersionLegalDocumentsDocumentIdVersionsPostMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof nmibleInstanceV3>;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createLegalDocumentVersionLegalDocumentsDocumentIdVersionsPost
      >
    >,
    TError,
    CreateLegalDocumentVersionLegalDocumentsDocumentIdVersionsPostMutationVariables,
    TContext
  > => {
    return useMutation(
      getCreateLegalDocumentVersionLegalDocumentsDocumentIdVersionsPostMutationOptions(
        options
      ),
      queryClient
    );
  };
/**
 * @summary Create New Version
 */
export const createNewVersionLegalDocumentsPost = (
  legalDocumentVersionCreate: BodyType<LegalDocumentVersionCreate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<LegalDocumentVersionRead>(
    {
      url: `/legal-documents/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: legalDocumentVersionCreate,
      signal,
    },
    options
  );
};

export const getCreateNewVersionLegalDocumentsPostMutationKey = () =>
  ["createNewVersionLegalDocumentsPost"] as const;

export const getCreateNewVersionLegalDocumentsPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNewVersionLegalDocumentsPost>>,
    TError,
    CreateNewVersionLegalDocumentsPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createNewVersionLegalDocumentsPost>>,
  TError,
  CreateNewVersionLegalDocumentsPostMutationVariables,
  TContext
> => {
  const mutationKey = getCreateNewVersionLegalDocumentsPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createNewVersionLegalDocumentsPost>>,
    CreateNewVersionLegalDocumentsPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createNewVersionLegalDocumentsPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateNewVersionLegalDocumentsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createNewVersionLegalDocumentsPost>>
>;
export type CreateNewVersionLegalDocumentsPostMutationBody =
  BodyType<LegalDocumentVersionCreate>;
export type CreateNewVersionLegalDocumentsPostMutationError =
  ErrorType<HTTPValidationError>;
export interface CreateNewVersionLegalDocumentsPostMutationVariables {
  data: BodyType<LegalDocumentVersionCreate>;
}

/**
 * @summary Create New Version
 */
export const useCreateNewVersionLegalDocumentsPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createNewVersionLegalDocumentsPost>>,
      TError,
      CreateNewVersionLegalDocumentsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createNewVersionLegalDocumentsPost>>,
  TError,
  CreateNewVersionLegalDocumentsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateNewVersionLegalDocumentsPostMutationOptions(options),
    queryClient
  );
};
/**
 * Update an existing legal document version
 * @summary Update Legal Document Version
 */
export const updateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPut =
  (
    documentId: string,
    versionId: string,
    legalDocumentVersionUpdate: BodyType<LegalDocumentVersionUpdate>,
    options?: SecondParameter<typeof nmibleInstanceV3>,
    signal?: AbortSignal
  ) => {
    return nmibleInstanceV3<LegalDocumentVersionCreateResponse>(
      {
        url: `/legal-documents/${documentId}/versions/${versionId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        data: legalDocumentVersionUpdate,
        signal,
      },
      options
    );
  };

export const getUpdateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPutMutationKey =
  () =>
    [
      "updateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPut",
    ] as const;

export const getUpdateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPutMutationOptions =
  <
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPut
        >
      >,
      TError,
      UpdateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPut
      >
    >,
    TError,
    UpdateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPutMutationVariables,
    TContext
  > => {
    const mutationKey =
      getUpdateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPutMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPut
        >
      >,
      UpdateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPutMutationVariables
    > = (props) => {
      const { documentId, versionId, data } = props ?? {};

      return updateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPut(
        documentId,
        versionId,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPut
      >
    >
  >;
export type UpdateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPutMutationBody =
  BodyType<LegalDocumentVersionUpdate>;
export type UpdateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPutMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface UpdateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPutMutationVariables {
  documentId: string;
  versionId: string;
  data: BodyType<LegalDocumentVersionUpdate>;
}

/**
 * @summary Update Legal Document Version
 */
export const useUpdateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPut =
  <TError = ErrorType<ErrorResponse | HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPut
          >
        >,
        TError,
        UpdateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPutMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof nmibleInstanceV3>;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPut
      >
    >,
    TError,
    UpdateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPutMutationVariables,
    TContext
  > => {
    return useMutation(
      getUpdateLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdPutMutationOptions(
        options
      ),
      queryClient
    );
  };
/**
 * Delete a legal document version (soft delete)
 * @summary Delete Legal Document Version
 */
export const deleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDelete =
  (
    documentId: string,
    versionId: string,
    options?: SecondParameter<typeof nmibleInstanceV3>,
    signal?: AbortSignal
  ) => {
    return nmibleInstanceV3<void>(
      {
        url: `/legal-documents/${documentId}/versions/${versionId}`,
        method: "DELETE",
        signal,
      },
      options
    );
  };

export const getDeleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDeleteMutationKey =
  () =>
    [
      "deleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDelete",
    ] as const;

export const getDeleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDeleteMutationOptions =
  <
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDelete
        >
      >,
      TError,
      DeleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDelete
      >
    >,
    TError,
    DeleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDeleteMutationVariables,
    TContext
  > => {
    const mutationKey =
      getDeleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDeleteMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDelete
        >
      >,
      DeleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDeleteMutationVariables
    > = (props) => {
      const { documentId, versionId } = props ?? {};

      return deleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDelete(
        documentId,
        versionId,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDelete
      >
    >
  >;

export type DeleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDeleteMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface DeleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDeleteMutationVariables {
  documentId: string;
  versionId: string;
}

/**
 * @summary Delete Legal Document Version
 */
export const useDeleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDelete =
  <TError = ErrorType<ErrorResponse | HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDelete
          >
        >,
        TError,
        DeleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDeleteMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof nmibleInstanceV3>;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDelete
      >
    >,
    TError,
    DeleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDeleteMutationVariables,
    TContext
  > => {
    return useMutation(
      getDeleteLegalDocumentVersionLegalDocumentsDocumentIdVersionsVersionIdDeleteMutationOptions(
        options
      ),
      queryClient
    );
  };
/**
 * Upload one or more PDFs for this version. Each filename sets the language.
 * @summary Upload Legal Document Version Files
 */
export const uploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost =
  (
    documentId: string,
    versionId: string,
    bodyUploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost: BodyType<BodyUploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost>,
    options?: SecondParameter<typeof nmibleInstanceV3>,
    signal?: AbortSignal
  ) => {
    const formData = new FormData();
    bodyUploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost.files.forEach(
      (value) => formData.append(`files`, value)
    );

    return nmibleInstanceV3<LegalDocumentVersionFileRead[]>(
      {
        url: `/legal-documents/${documentId}/versions/${versionId}/files`,
        method: "POST",
        headers: { "Content-Type": "multipart/form-data" },
        data: formData,
        signal,
      },
      options
    );
  };

export const getUploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPostMutationKey =
  () =>
    [
      "uploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost",
    ] as const;

export const getUploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPostMutationOptions =
  <
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof uploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost
        >
      >,
      TError,
      UploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof uploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost
      >
    >,
    TError,
    UploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getUploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof uploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost
        >
      >,
      UploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPostMutationVariables
    > = (props) => {
      const { documentId, versionId, data } = props ?? {};

      return uploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost(
        documentId,
        versionId,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof uploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost
      >
    >
  >;
export type UploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPostMutationBody =
  BodyType<BodyUploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost>;
export type UploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPostMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface UploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPostMutationVariables {
  documentId: string;
  versionId: string;
  data: BodyType<BodyUploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost>;
}

/**
 * @summary Upload Legal Document Version Files
 */
export const useUploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost =
  <TError = ErrorType<ErrorResponse | HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof uploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost
          >
        >,
        TError,
        UploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPostMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof nmibleInstanceV3>;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof uploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPost
      >
    >,
    TError,
    UploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPostMutationVariables,
    TContext
  > => {
    return useMutation(
      getUploadLegalDocumentVersionFilesLegalDocumentsDocumentIdVersionsVersionIdFilesPostMutationOptions(
        options
      ),
      queryClient
    );
  };
/**
 * Register an externally hosted document as this version's file.
 *
 * Use instead of the PDF upload when a third party publishes the document
 * (e.g. Stripe's E-Sign Disclosure and Authorized User Terms). The link is
 * stored as the default-language (``en``) file; participants whose language
 * has no file of its own receive it too. Calling again replaces the link.
 * @summary Set Legal Document Version Link
 */
export const setLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPut =
  (
    documentId: string,
    versionId: string,
    legalDocumentVersionLinkRequest: BodyType<LegalDocumentVersionLinkRequest>,
    options?: SecondParameter<typeof nmibleInstanceV3>,
    signal?: AbortSignal
  ) => {
    return nmibleInstanceV3<LegalDocumentVersionFileRead>(
      {
        url: `/legal-documents/${documentId}/versions/${versionId}/files`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        data: legalDocumentVersionLinkRequest,
        signal,
      },
      options
    );
  };

export const getSetLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPutMutationKey =
  () =>
    [
      "setLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPut",
    ] as const;

export const getSetLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPutMutationOptions =
  <
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPut
        >
      >,
      TError,
      SetLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof setLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPut
      >
    >,
    TError,
    SetLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPutMutationVariables,
    TContext
  > => {
    const mutationKey =
      getSetLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPutMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof setLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPut
        >
      >,
      SetLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPutMutationVariables
    > = (props) => {
      const { documentId, versionId, data } = props ?? {};

      return setLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPut(
        documentId,
        versionId,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SetLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof setLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPut
      >
    >
  >;
export type SetLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPutMutationBody =
  BodyType<LegalDocumentVersionLinkRequest>;
export type SetLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPutMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface SetLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPutMutationVariables {
  documentId: string;
  versionId: string;
  data: BodyType<LegalDocumentVersionLinkRequest>;
}

/**
 * @summary Set Legal Document Version Link
 */
export const useSetLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPut =
  <TError = ErrorType<ErrorResponse | HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof setLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPut
          >
        >,
        TError,
        SetLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPutMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof nmibleInstanceV3>;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof setLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPut
      >
    >,
    TError,
    SetLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPutMutationVariables,
    TContext
  > => {
    return useMutation(
      getSetLegalDocumentVersionLinkLegalDocumentsDocumentIdVersionsVersionIdFilesPutMutationOptions(
        options
      ),
      queryClient
    );
  };
/**
 * List legal documents.
 *
 * - Authenticated participant: returns `pending` or `accepted` documents for them.
 * - Unauthenticated caller (e.g. login page): returns all active legal
 *   documents with their latest current version. `?status=accepted` is
 *   rejected with 401 since no participant context is available.
 * @summary List My Legal Documents
 */
export const listMyLegalDocumentsParticipantsMeLegalDocumentsGet = (
  params: ListMyLegalDocumentsParticipantsMeLegalDocumentsGetParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<PendingDocumentResponse[]>(
    { url: `/participants/me/legal-documents`, method: "GET", params, signal },
    options
  );
};

export const getListMyLegalDocumentsParticipantsMeLegalDocumentsGetQueryKey = (
  params?: ListMyLegalDocumentsParticipantsMeLegalDocumentsGetParams
) => {
  return [
    `/participants/me/legal-documents`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListMyLegalDocumentsParticipantsMeLegalDocumentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet>
    >,
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
  >(
    params: ListMyLegalDocumentsParticipantsMeLegalDocumentsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof nmibleInstanceV3>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListMyLegalDocumentsParticipantsMeLegalDocumentsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet>
      >
    > = ({ signal }) =>
      listMyLegalDocumentsParticipantsMeLegalDocumentsGet(
        params,
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ListMyLegalDocumentsParticipantsMeLegalDocumentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet>
    >
  >;
export type ListMyLegalDocumentsParticipantsMeLegalDocumentsGetQueryError =
  ErrorType<ErrorResponse | HTTPValidationError>;

export function useListMyLegalDocumentsParticipantsMeLegalDocumentsGet<
  TData = Awaited<
    ReturnType<typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params: ListMyLegalDocumentsParticipantsMeLegalDocumentsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMyLegalDocumentsParticipantsMeLegalDocumentsGet<
  TData = Awaited<
    ReturnType<typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params: ListMyLegalDocumentsParticipantsMeLegalDocumentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMyLegalDocumentsParticipantsMeLegalDocumentsGet<
  TData = Awaited<
    ReturnType<typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params: ListMyLegalDocumentsParticipantsMeLegalDocumentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List My Legal Documents
 */

export function useListMyLegalDocumentsParticipantsMeLegalDocumentsGet<
  TData = Awaited<
    ReturnType<typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params: ListMyLegalDocumentsParticipantsMeLegalDocumentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMyLegalDocumentsParticipantsMeLegalDocumentsGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListMyLegalDocumentsParticipantsMeLegalDocumentsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
